import React from 'react';

const TicketCard = ({ ticket, onClick, onDragStart, onDragEnd, isDragging }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return '#ef4444';
      case 'medium': return '#f59e0b';
      case 'low': return '#10b981';
      default: return '#64748b';
    }
  };

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'high': return '🔴';
      case 'medium': return '🟡';
      case 'low': return '🟢';
      default: return '⚪';
    }
  };

  return (
    <div
      className={`ticket-card ${isDragging ? 'dragging' : ''}`}
      onClick={onClick}
      draggable="true"
      onDragStart={(e) => {
        onDragStart();
        e.stopPropagation();
      }}
      onDragEnd={onDragEnd}
    >
      <div className="ticket-card-header">
        <span className="ticket-id">#{ticket.id}</span>
        <span className="ticket-priority" style={{ color: getPriorityColor(ticket.priority) }}>
          {getPriorityIcon(ticket.priority)}
        </span>
      </div>
      <h4 className="ticket-title">{ticket.title}</h4>
      {ticket.description && (
        <p className="ticket-description">
          {ticket.description.length > 80
            ? ticket.description.substring(0, 80) + '...'
            : ticket.description}
        </p>
      )}
      <div className="ticket-card-footer">
        {ticket.assignee && (
          <span className="ticket-assignee">
            👤 {ticket.assignee.username}
          </span>
        )}
        {ticket.job && (
          <span className={`ticket-job-status status-${ticket.job.status}`}>
            {ticket.job.status === 'running' ? '⚙️' : ticket.job.status === 'completed' ? '✅' : '❌'}
          </span>
        )}
      </div>
    </div>
  );
};

export default TicketCard;
